import { render, staticRenderFns } from "./Light.vue?vue&type=template&id=6e0cabd4&scoped=true&"
import script from "./Light.vue?vue&type=script&lang=js&"
export * from "./Light.vue?vue&type=script&lang=js&"
import style0 from "./Light.vue?vue&type=style&index=0&id=6e0cabd4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e0cabd4",
  null
  
)

export default component.exports